import { Menu as AntMenu } from 'antd';
import { MenuItemProps } from 'antd/lib/menu/MenuItem';
import React from 'react';

const { Item: AntItem } = AntMenu;

export interface IMenuItemProps extends MenuItemProps {}

/**
 * Menu component
 */
export const Item: React.FC<IMenuItemProps> = (props) => <AntItem {...props} />;
